const serve = '/api'

export default [
	{
		name: 'getQuestionState',
		method: 'get',
		url: serve + '/question-answer',
		params: {},
		docs: '题目数据统计'
	}
]
